export default "__VITE_ASSET__ecc5ee41__"